import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../assets/css/Chatbot.css';
import { FaWindowMinimize, FaSpinner } from 'react-icons/fa';
import { Websocket, chatbots, chatbotupload, ocrfile, xlsxfile } from '../components/ApiProperty';
import chatIcon from '../assets/images/chatbot_v2.png';
import { UploadButtonStyle } from "../components/Propertyfile";
import { useChatbot } from "../components/ChatbotContext";
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';


const Chatbot = () => {
  const [messages, setMessages] = useState([
    { text: "<b>Hi, Welcome to Gapsphere.AI!</b> <br> Hello, I'm Gapsy your Intelligent Assistant", sender: "bot", timestamp: new Date() }
  ]);
  const [input, setInput] = useState("");
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showUploadButton, setShowUploadButton] = useState(false);
  const [uploadPromptVisible, setUploadPromptVisible] = useState(false);
  const filePromptShownRef = useRef(false);
  const [isMinimized, setIsMinimized] = useState(true);
  const [sheetNames, setSheetNames] = useState([]);
  const [showSheetSelection, setShowSheetSelection] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const wsRef = useRef(null);
  const [mainSheet, setMainSheet] = useState(null);
  const [selectedSheets, setSelectedSheets] = useState([]);
  const navigate = useNavigate();
  const { isChatbotMinimized, setIsChatbotMinimized, isChatbotVisible, setIsChatbotVisible } = useChatbot();
  let csrfToken = sessionStorage.getItem("tokenizedSession");



  useEffect(() => {
    console.log("Chatbot state: ", { isChatbotMinimized, isChatbotVisible });
  }, [isChatbotMinimized, isChatbotVisible]);

  const predefinedAnswers = {
    "what is your name?": "I'm your friendly chatbot.",
    "how can you help me?": "I can assist with a variety of tasks, just ask!",
    "what is the weather today?": "I'm not sure, but you can check a weather app for the latest updates.",
    "help": "You can ask me questions or tell me what you need help with.",
  };

  const role = localStorage.getItem("userRole");
  useEffect(() => {
    const savedMessages = localStorage.getItem("chatMessages");
    if (savedMessages) {
      setMessages(JSON.parse(savedMessages));
    }
    scrollToBottom();
  }, []);

  useEffect(() => {
    // Initialize WebSocket connection
    wsRef.current = new WebSocket(Websocket);

    wsRef.current.onopen = () => {
      console.log("WebSocket connected");
    };

    wsRef.current.onmessage = (event) => {
      setLoading(false);
      console.log("Received message from WebSocket:", event.data);

      try {
        const data = JSON.parse(event.data);
        const localSessionId = localStorage.getItem("sessionId"); // Get sessionId from localStorage
        let selectedFileName = null;

        // Check if sessionId matches
        if (data.sessionId === localSessionId) {

          let botReply;
          let botReplyData;

          if (data.data) {
            try {
              botReplyData = JSON.parse(data.data); // Parse the JSON string in `data.data`
            } catch (error) {
              console.error("Failed to parse data field:", error);
              botReply = "Error in data format.";
              return;
            }
          }

          if (data.intent == "INTENT_PROMPT") {
            botReply = data.text;
          }
          else if (data.intent == "INTENT_API_MODIFY_TEMPLATE_AI") {
            let dataOfMTemplate = JSON.parse(data.data);
            localStorage.setItem("tablename", dataOfMTemplate.table_name);
            botReply = `<a href="${data.link}" rel="noopener noreferrer" class="chatbot-link">View All</a><br>${data.text}`;

          }
          else if (data.intent == "INTENT_API_MODIFY_TEMPLATE_AI_NEW_TEMPLATE") {
            let dataOfMTemplate = JSON.parse(data.data);
            localStorage.setItem("tablename", dataOfMTemplate.table_name);
            botReply = `<a href="${data.link}" rel="noopener noreferrer" class="chatbot-link">View All</a><br>${data.text}`;

          }
          else if (data.intent == "INTENT_API_CREATE_TEMPLATE_AI") {

            botReply = `<a href="${data.link}" rel="noopener noreferrer" class="chatbot-link">View All</a>`;
            localStorage.setItem("designtemplate", data.data);
            setLoading(false);
          }
          else if (data.intent == "INTENT_API_BULK_UPLOAD_TEMPLATE") {

            botReply = `<a href="${data.link}" rel="noopener noreferrer" class="chatbot-link">View All</a>`;
            localStorage.setItem("designtemplate", data.data);
          }
          else if (data.intent === "INTENT_API_QUERY_TABLE") {
            try {
              const parsedData = JSON.parse(data.data); // Parse the nested JSON string
              if (parsedData.table_name) {
                const cleanTableName = parsedData.table_name.replace(/\.json$/i, ""); // remove .json if present
                localStorage.setItem("reporttablename", cleanTableName);
                console.log("Stored tablename:", cleanTableName);
              } else {
                console.warn("table_name not found in INTENT_API_QUERY_TABLE data");
              }
              if (data.link) {
                // Update auto-increment in localStorage
                let autoIncrement = parseInt(localStorage.getItem("autoIncrement") || "0", 10);
                autoIncrement = autoIncrement >= 10 ? 1 : autoIncrement + 1;
                localStorage.setItem("autoIncrement", autoIncrement);
                console.log("AutoIncrement updated:", autoIncrement);

                botReply = `<a href="${data.link}" rel="noopener noreferrer" class="chatbot-link">View All</a><br>${data.text || ""}`;
              } else {
                botReply = data.text || "Table query completed.";
              }


            } catch (error) {
              console.error("Failed to parse INTENT_API_QUERY_TABLE data:", error);
              botReply = "Error processing table query response.";
            }
          }

          else if (data.intent === "INTENT_API_AI_BULK_UPLOAD_NEW_TEMPLATE") {

            if (!selectedFile && !filePromptShownRef.current) {
              filePromptShownRef.current = true;  // prevent further prompts

              const fileInput = document.createElement("input");
              fileInput.type = "file";
              fileInput.style.display = "none";
              document.body.appendChild(fileInput);
              fileInput.click();

              fileInput.addEventListener("change", async (event) => {
                const file = event.target.files[0];
                if (file) {
                  setSelectedFile(file);

                  const reader = new FileReader();

                  if (file.name.endsWith(".xlsx") || file.name.endsWith(".xls")) {
                    reader.onload = (e) => {
                      const data = new Uint8Array(e.target.result);
                      const workbook = XLSX.read(data, { type: "array" });
                      const sheets = workbook.SheetNames;

                      // Sanitize all cells in all sheets
                      sheets.forEach(sheetName => {
                        const sheet = workbook.Sheets[sheetName];
                        const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false, cellText: true, cellDates: false });

                        const sanitizedRows = sheetData.map(row =>
                          row.map(cell => {
                            if (typeof cell === 'string') {
                              return cell.replace(/(\r\n|\n|\r)/g, ' '); // replace newlines with space
                            }
                            return cell;
                          })
                        );

                        const worksheet = XLSX.utils.aoa_to_sheet(sanitizedRows);
                        workbook.Sheets[sheetName] = worksheet;
                      });

                      setSheetNames(sheets);
                      filePromptShownRef.current = false;
                      setUploadPromptVisible(false);
                      setShowSheetSelection(true);
                    };
                    reader.readAsArrayBuffer(file);
                  }
                  else if (file.name.endsWith(".csv") || file.name.endsWith(".txt")) {
                    reader.onload = (e) => {
                      const fileContent = e.target.result;

                      let delimiter = ",";
                      if (file.name.endsWith(".txt")) {
                        if (fileContent.includes("\t")) delimiter = "\t";
                        else if (fileContent.includes("|")) delimiter = "|";
                      }

                      const rows = fileContent
                        .split(/\r?\n/)
                        .filter((line) => line.trim().length > 0)
                        .map((line) =>
                          line.split(delimiter).map(cell => {
                            if (typeof cell === 'string') return cell.replace(/(\r\n|\n|\r)/g, ' ');
                            return cell;
                          })
                        );

                      const worksheet = XLSX.utils.aoa_to_sheet(rows);
                      const workbook = XLSX.utils.book_new();
                      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

                      const sheets = workbook.SheetNames;
                      setSheetNames(sheets);
                      filePromptShownRef.current = false;
                      setUploadPromptVisible(false);
                      setShowSheetSelection(true);
                    };
                    reader.readAsText(file);
                  }
                  else {
                    console.warn("Unsupported file type");
                    setUploadPromptVisible(true);
                    filePromptShownRef.current = false;
                  }
                }

                document.body.removeChild(fileInput);
              });


            } else {
              console.log("File already selected or prompt already shown. Skipping browse popup.");
            }
          }


          else {
            if (data.text && data.link) {
              botReply = `<a href="${data.link}" rel="noopener noreferrer" class="chatbot-link">View All</a><br>${data.text}`;
            }
            else if (data.text) {
              botReply = data.text;

            }
            else {
              botReply = `<a href="${data.link}" rel="noopener noreferrer" class="chatbot-link">Preview</a>`;
            }
          }

          setMessages(prevMessages => [
            ...prevMessages,
            { text: botReply, sender: "bot", timestamp: new Date() }
          ]);
        }

      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    wsRef.current.onclose = () => {
      console.log("WebSocket disconnected. Reconnecting...");
      setTimeout(() => {
        wsRef.current = new WebSocket(Websocket);
      }, 5000);
    };

    return () => {
      wsRef.current.close();
    };
  }, []);

  useEffect(() => {
    if (sheetNames.length === 1) {
      const onlySheet = sheetNames[0];
      setSelectedSheets([onlySheet]);
      setMainSheet(onlySheet);
      setUploadPromptVisible(true);  // Show upload button or prompt, if relevant
      setShowSheetSelection(false);  // Hide the sheet selection UI
    } else if (sheetNames.length > 1) {
      setShowSheetSelection(true); // Show sheet selection UI if more than one
    }
  }, [sheetNames]);

  useEffect(() => {
    localStorage.setItem("chatMessages", JSON.stringify(messages));
    scrollToBottom();
  }, [messages]);

  const sendMessage = () => {
    if (input.trim() !== "") {
      const newMessage = { text: input, sender: "user", timestamp: new Date() };
      setMessages(prevMessages => [...prevMessages, newMessage]);
      setInput("");
      setLoading(true);

      const predefinedReply = predefinedAnswers[input.toLowerCase()];

      if (predefinedReply) {
        setMessages(prevMessages => [
          ...prevMessages,
          { text: predefinedReply, sender: "bot", timestamp: new Date() }
        ]);
        setLoading(false);
      } else if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        // Send the message via WebSocket if connection is open
        wsRef.current.send(JSON.stringify({
          sessionId: localStorage.getItem('sessionId'),
          userId: localStorage.getItem('userid'),
          text: input,
          role: localStorage.getItem('userRole')
        }));
      }

      const config = {
        headers: {
          userId: localStorage.getItem('userid'), // Ensure this is the correct case
          sessionId: localStorage.getItem('sessionId'), // Ensure this is the correct case
          "x-csrf-token": csrfToken
        },
        params: {
          message: input, // Passing input as a URL parameter
          role: localStorage.getItem('userRole'), // Passing role as a URL parameter
          dept: localStorage.getItem('dept'),
        }
      };

      // Use an empty object as the second argument since you're passing params in the config
      const response = axios.post(chatbots, {}, config)
        .then(response => {
          console.log("API response:", response.data);
          // Process API response here if needed
        })
        .catch(error => {
          console.error("API error:", error);
        });
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  const handleMinimize = () => setIsChatbotMinimized(prev => !prev);

  const handleLinkClick = (event) => {
    event.preventDefault();
    const link = event.target.getAttribute('href');
    if (link) {
      navigate(link.startsWith("/") ? link : `/chatbot`); // Ensure internal navigation
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    const lastDotIndex = selectedFile.name.lastIndexOf('.');
    const fileNameWithoutExtension = lastDotIndex !== -1
      ? selectedFile.name.substring(0, lastDotIndex)
      : selectedFile.name;
    const fileExtension = lastDotIndex !== -1
      ? selectedFile.name.substring(lastDotIndex)
      : '';

    try {
      setLoading(true);

      // Step 1: Read and parse the Excel file
      const data = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(data, { type: 'array' });

      let finalRows = [];
      let headerRow = [];

      selectedSheets.forEach(sheetName => {
        const sheet = workbook.Sheets[sheetName];
        const sheetData = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          raw: false,
          cellText: true,
          cellDates: false
        });


        if (!sheetData.length) return;

        const headerLength = sheetData[0].length;
        const normalizedRows = sheetData.map(row =>
          Array.from({ length: headerLength }, (_, i) => row[i] ?? "")
        );

        if (sheetName === mainSheet) {
          headerRow = normalizedRows[0]; // Save the header row
          const dataRows = normalizedRows.slice(1); // Skip header
          finalRows = [...finalRows, ...dataRows];
        } else {
          const dataRows = normalizedRows.slice(1); // Skip header
          finalRows = [...finalRows, ...dataRows];
        }
      });

      const combinedData = [headerRow, ...finalRows];
      const newSheet = XLSX.utils.aoa_to_sheet(combinedData);
      const newWorkbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(newWorkbook, newSheet, 'ProcessedData');

      // Step 2: Convert and upload the new file
      const excelBuffer = XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' });
      const newBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      // const processedFile = new File([newBlob], selectedFile.name, { type: selectedFile.type });
      const processedFile = new File(
        [newBlob],
        `${fileNameWithoutExtension}.xlsx`, //  force .xlsx filename
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );


      const formData = new FormData();
      formData.append('file', processedFile);

      const uploadResponse = await axios.post(xlsxfile, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "x-csrf-token": csrfToken,
          userId: localStorage.getItem('userid'),
        },
      });

      if (uploadResponse.status === 200) {
        console.log("File uploaded to OCR server");

        // Step 3: Trigger chatbotupload API
        const config = {
          headers: {
            userId: localStorage.getItem('userid'),
            sessionId: localStorage.getItem('sessionId'),
            "x-csrf-token": csrfToken,
          },
          params: {
            fileName: fileNameWithoutExtension,
            role: role,
            format: ".xlsx",
          },
        };

        const response = await axios.post(chatbotupload, {}, config);

        localStorage.setItem('uploadedFileName', selectedFile.name);

        // Cleanup UI and state
        setSelectedFile(null);
        setShowUploadButton(false);
        setUploadPromptVisible(false);
        setSelectedSheets([]);
        setMainSheet(null);
        setShowSheetSelection(false);
        filePromptShownRef.current = false; //  allow prompt again for future uploads
        setMessages(prev => [...prev, {
          sender: 'bot',
          text: `✅ File "${selectedFile.name}" uploaded successfully.`,
          timestamp: new Date()
        }]);
      }

    } catch (error) {
      console.error("Upload failed:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    localStorage.setItem("isChatbotMinimized", isMinimized);
  }, [isMinimized]);


  if (!isVisible) return null;

  if (!isChatbotVisible) return null;

  return (
    <div className={`chatbot-container card ${isChatbotMinimized ? 'minimized' : ''}`}
      onClick={(event) => {
        if (event.target.classList.contains('chatbot-link')) {
          handleLinkClick(event);
        }
      }}>

      {!isChatbotMinimized ? (
        <>
          <div className="card-header-gapsy text-center text-white d-flex justify-content-between align-items-center card-bot">
            <span>Gapsy</span>
            <div>
              <button className="btn btn-sm mx-1 text-white btn-bot" onClick={handleMinimize}>
                <FaWindowMinimize />
              </button>
            </div>
          </div>
          <div className="card-body chatbot-messages">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`message ${message.sender} ${index === 0 ? "highlight" : ""}`} // Only apply highlight to the first message
              >
                <div
                  className={`message-text ${message.sender === 'user' ? 'custom-primary text-black' : 'bg-light'}`}
                  dangerouslySetInnerHTML={{
                    // __html: message.text.replace(/\n/g, '<br>') 
                    __html: typeof message.text === 'string'
                      ? message.text.replace(/\n/g, '<br>')
                      : ''

                  }}
                />
                <div className="timestamp">
                  {formatTimestamp(message.timestamp)}
                </div>
              </div>
            ))}
            {sheetNames.length > 0 && showSheetSelection && (
              <div style={{ marginTop: '10px' }}>
                <button className="btn btn-outline-secondary btn-sm">
                  Select Sheets
                </button>
                {sheetNames.map((sheet, index) => (
                  <li key={index} className="d-flex align-items-center gap-2 p-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={sheet}
                      value={sheet}
                      onChange={(e) => {
                        const sheetName = e.target.value;
                        if (e.target.checked) {
                          if (selectedSheets.length === 0) {
                            setMainSheet(sheetName); // first one is main
                          }
                          setSelectedSheets(prev => [...prev, sheetName]);
                          setUploadPromptVisible(true);
                        } else {
                          setSelectedSheets(prev => prev.filter(s => s !== sheetName));
                          if (sheetName === mainSheet) setMainSheet(null);
                        }
                      }}
                    />


                    <label htmlFor={sheet}>{sheet}</label>
                  </li>
                ))}
              </div>
            )}


            {uploadPromptVisible && selectedFile && (
              <div>
                <button style={UploadButtonStyle} className="btn btn-primary btn-sm mx-2" onClick={handleUpload}>Upload</button>
              </div>
            )}


            {loading && (
              <div className="message bot">
                <div className="message-text bg-light">
                  <FaSpinner className="fa-spin" /> Generating
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
          <div className="card-footer">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Type a message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
              />
              <button
                className="btn btn-gapsy-custom"
                onClick={sendMessage}
                disabled={loading}
              >
                Send
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="chat-icon" onClick={() => setIsChatbotMinimized(false)}>
          <img src={chatIcon} alt="Chat Icon" className="chat-icon-image" />
        </div>
      )}
    </div>
  );
};

export default Chatbot;
